export const MAX_TRANSIT_DAYS = 60;

export interface TransitDaysError {
  field: 'days';
  message: string;
}

export function validateTransitDays(text: string): TransitDaysError | null {
  const ok = /^\d+$/.test(text.trim()) && Number(text) <= MAX_TRANSIT_DAYS;
  return ok ? null : { field: 'days', message: `Enter whole days from 0 to ${MAX_TRANSIT_DAYS}.` };
}
